import { useState } from "react";
import { hotTopics, editorPicks } from "@/mocks/baoliaoData";

export default function TopicBoard() {
  const [activeTopic, setActiveTopic] = useState(hotTopics[0].tag);
  const maxHeat = hotTopics[0].heat;

  const active = hotTopics.find((t) => t.tag === activeTopic) || hotTopics[0];

  return (
    <section id="topics" className="py-10 md:py-16 bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-semibold tracking-wider uppercase">
              <i className="ri-hashtag"></i>
              吃瓜话题榜
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl tracking-tight text-foreground-950 mt-1">
              正在刷屏的话题
            </h2>
            <p className="text-xs text-foreground-500 mt-1">点击话题查看对应热度走势，掌握讨论声量</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8">
          {/* topics heat board */}
          <div className="lg:col-span-3">
            <div className="rounded-2xl border border-background-200 bg-background-100/60 p-5 md:p-6">
              <div className="flex flex-col gap-4">
                {hotTopics.map((t) => {
                  const width = Math.round((t.heat / maxHeat) * 100);
                  const isActive = activeTopic === t.tag;
                  return (
                    <button
                      key={t.tag}
                      onClick={() => setActiveTopic(t.tag)}
                      className={`group text-left flex items-center gap-4 rounded-xl px-3 py-2.5 transition-colors ${
                        isActive ? "bg-background-50 border border-primary-200" : "hover:bg-background-50/70"
                      }`}
                    >
                      <span
                        className={`font-display text-base w-7 shrink-0 text-center ${
                          isActive ? "text-primary-500" : "text-foreground-400"
                        }`}
                      >
                        {String(hotTopics.indexOf(t) + 1).padStart(2, "0")}
                      </span>
                      <span className="flex-1 min-w-0">
                        <span
                          className={`block text-sm font-semibold truncate ${
                            isActive ? "text-primary-600" : "text-foreground-800"
                          }`}
                        >
                          {t.tag}
                        </span>
                        <span className="block h-1.5 rounded-full bg-background-200 mt-2 overflow-hidden">
                          <span
                            className={`block h-full rounded-full transition-all duration-500 ${
                              isActive ? "bg-primary-500" : "bg-accent-500/70"
                            }`}
                            style={{ width: `${width}%` }}
                          ></span>
                        </span>
                      </span>
                      <span className="shrink-0 text-xs font-medium text-foreground-500 whitespace-nowrap">
                        {t.heat}万
                      </span>
                      {isActive && <i className="ri-check-line text-primary-500 text-sm"></i>}
                    </button>
                  );
                })}
              </div>

              <div className="mt-5 flex items-center gap-3 rounded-xl bg-foreground-950 px-4 py-3.5">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-line-chart-line text-lg"></i>
                </span>
                <div className="min-w-0">
                  <p className="text-[11px] text-background-100/60">当前热度最高的讨论</p>
                  <p className="text-sm font-semibold text-background-50 truncate">{active.tag}</p>
                </div>
                <span className="ml-auto shrink-0 text-xs font-bold text-accent-300 whitespace-nowrap">
                  {active.heat}万热度
                </span>
              </div>
            </div>
          </div>

          {/* editor picks */}
          <div className="lg:col-span-2">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 h-full">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading font-extrabold text-lg text-foreground-950 flex items-center gap-2">
                  <i className="ri-edit-2-line text-accent-500"></i>
                  编辑精选
                </h3>
                <span className="text-[11px] text-foreground-500">深度梳理 · 每日更新</span>
              </div>
              <ul className="flex flex-col divide-y divide-background-200/80">
                {editorPicks.map((p, i) => (
                  <li key={i}>
                    <a href="#track" className="group flex gap-3 py-3.5 first:pt-1 last:pb-1">
                      <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 text-xs font-bold group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                        {i + 1}
                      </span>
                      <span className="flex-1 min-w-0">
                        <span className="block text-[13px] md:text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                          {p.title}
                        </span>
                        <span className="block text-[11px] text-foreground-500 mt-1.5">
                          {p.cat} · {p.time} · {p.views} 阅读
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}